exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".LineUpContents__LineUpContents__17X3P {\n  position: relative;\n  width: 100%;\n  height: 235px;\n  z-index: 3; }\n  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {\n    .LineUpContents__LineUpContents__17X3P {\n      margin: 48.5px 0 38.5px 0; } }\n  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {\n    .LineUpContents__LineUpContents__17X3P {\n      margin: 48.5px 0 38.5px 0; } }\n  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {\n    .LineUpContents__LineUpContents__17X3P {\n      margin: 48.5px 0 38.5px 0; } }\n", ""]);

// exports
exports.locals = {
	"LineUpContents": "LineUpContents__LineUpContents__17X3P"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/circleci/project/src/styles"]}!./src/app/intro/components/LineUpContents/LineUpContents.scss
// module id = 668
// module chunks = 0